import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar/Navbar';
import Footer from '../components/Footer/Footer';
import images from '../constants/images';
import SubHeading from '../components/SubHeading/SubHeading';
import OneColumnB from '../components/OneColumnB/OneColumnB';
import Events from '../components/EventBanner/EventBanner';
import './Views.css'


const Home = () => {


  return (
    <div>
      <Navbar />
       <Events expiryDate="2025-11-08T12:00:00Z"/>
      <div className="app__background-bk app__hero section__padding" id="home">
        <div className="app__hero_info">
          <SubHeading title="Bringing the world's game to rural America" />
          <h1 className="app__header" style={{color: 'var(--color-purple)'}}>Collaborate.</h1>
          <h1 className="app__header" style={{color: 'var(--color-purple)'}}>Problem-solve.</h1>
          <h1 className="app__header" style={{color: 'var(--color-purple)'}}>Achieve.</h1>
          <p className="p__opensans" style={{ margin: '2rem 0' }}> Experience the joy of teamwork, the rush of scoring goals,
            and the camaraderie that comes with playing soccer. Join our passionate community of players who share a love for the sport and a competitive spirit.</p>
        </div>
        <div className="app__hero_img">
          <img className="hero__img" src={images.home_hero} alt="img" />
        </div>
      </div>
     
      <div className="app__background section__padding">
        <OneColumnB
          titleTwo="Mission"
          paragraph="We believe in developing players and individuals through collaboration, 
        problem-solving, and character-building. By empowering a growth mindset, fostering teamwork,
         and nurturing potential, we aim to cultivate success on and off the field. Our mission is to 
         create a supportive environment where athletes can thrive and reach their full potential."
        />
      </div>
      <div className="app__background section__padding">
        <OneColumnB
          titleTwo="Programs"
          subtitle="Recreational"
          subheader="U6 - U12 yrs"
          paragraph="Our recreational program is great way day to enjoy Saturday morning soccer in Orion. 
          This non-competitive atmosphere allows players to learn the game and new skills. 
          We provide the environment while the players bring the fun- rain or shine!"

        />
        <div className="app__background" style={{paddingTop: '1rem', paddingBottom: '3rem'}}>
          <button  className="app__button" type="button" > <Link to="/recreation"> Recreation</Link>  </button>
        </div>
        <OneColumnB
          subtitle="Competitive"
          subheader="U9 - U14 yrs"
          paragraph="Our competitive program teams consist of players from the Quad City area. Games are played Saturdays and Sundays. Competitive teams also participate in tournaments within and outside the Quad Cities."

        />
         
       
        <div className="app__background" style={{paddingTop: '1rem', paddingBottom: '3rem'}} >
          <button style={{ backgroundColor: 'var(--color-red)' }} className="app__button" type="button"> <Link to="/competitive"> Competitive</Link> </button>
        </div>
      
      </div>

      <div>
        <Footer />
      </div>
    </div>
  )
}

export default Home